import React from "react";
import Icon from "js/react/components/Icon";

export default function Avatar({ url, onClick, id }) {
    return (
        <div id={id} className="avatar" onClick={onClick}>
            {url ? <img src={url} /> : <Icon iconName="person" />}
        </div>
    );
}

export function TeamAvatar({ url }) {
    return (
        <div className="avatar">
            {url ? <img src={url} /> : <Icon iconName="people" />}
        </div>
    );
}

export function OrgAvatar({ url }) {
    return (
        <div className="avatar">
            {url ? <img src={url} /> : <Icon iconName="business" />}
        </div>
    );
}

export function Profile({ profile }) {
    const { photoURL, displayName, email, onClick } = profile;
    return (
        <div className="profile" onClick={onClick}>
            <Avatar url={photoURL} />
            <div className={displayName ? "name-email" : "email-only"}>
                { displayName
                    ? (<><div className="name">{displayName}</div><div className="email">{email}</div></>)
                    : <div className="email">{email}</div>
                }
            </div>
        </div>
    );
}
